import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/riwayat-perkawinan-ralan", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/riwayat-perkawinan-ralan/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/riwayat-perkawinan-ralan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function latestByPasien(rm: string | number) {
  const response = await http
    .getData(`/pasien/${rm}/riwayat-perkawinan-terakhir`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/riwayat-perkawinan-ralan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPerawat(id: number, data) {
  const response = await http
    .putData(`/riwayat-perkawinan-ralan/${id}/sign-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http
    .putData(`/riwayat-perkawinan-ralan/${id}/sign-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/riwayat-perkawinan-ralan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/riwayat-perkawinan-ralan/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  latestByPasien,
  find,
  signPerawat,
  signDpjp,
  destroy,
  print
};
